import { FC, ReactNode } from 'react';

interface ControlBarOptionsProps {
  title: string;
  children?: ReactNode;
}

const ControlBarOptions: FC<ControlBarOptionsProps> = ({ title, children }) => {
  return (
    <div className="ml-5 flex flex-row justify-between">
      <div className="mr-2.5 flex min-w-0 flex-1 items-center pr-2">
        <h6 className="truncate text-xl font-medium">{title}</h6>
      </div>
      {children}
    </div>
  );
};

export default ControlBarOptions;
